import { useContext } from 'react';
import { SystemConfigContext } from '../context/SystemConfigContext';

export const useSystemConfig = () => {
    const context = useContext(SystemConfigContext);
    if (!context) throw new Error('useSystemConfig must be used within a SystemConfigProvider');
    return context;
};
